<template>
  <div class="topic-covered">
    <ul class="topic-covered__list">
      <li class="list__item" v-for="(topic, index) in topicList" :key="index">
        <span class="list__item-date">{{ dateCorrect(topic.datetime) }}</span>
        <div class="item-text__wrp">
          <div
            :ref="`item-${index}`"
            :class="[
              'list__item-text',
              activeIndex === index ? 'focus-active' : '',
            ]"
            :contenteditable="activeIndex === index"
          >
            {{ topic.theme ? topic.theme : "" }}
          </div>
          <button
            class="list__item-cancel-btn"
            v-if="activeIndex === index"
            @click="cancelUpdate(index, topic)"
          >
            <i class="el-icon-circle-close"></i>
          </button>
  
          <transition name="fade">
            <div v-if="activeIndex === index" class="list__control-block">
              <span class="lable-select-hour">Продолжительность</span>
              <span class="lable-select-type">Тип</span>
              <el-select
                class="select-hour"
                v-model="topic.hour"
                placeholder="По умолчанию 2ч"
              >
                <el-option 
                  v-for="item in inputHours" 
                  :key="item" 
                  :label="`${item} ${plural(item, ['час', 'часа', 'часов'])}`"
                  :value="item"
                />
              </el-select>
              <p>{{ topic.type }}</p>
            </div>
          </transition>
        </div>

        <div class="button-box">
          <div
            :class="[
              'button-container',
              activeIndex === index ? 'container-shift' : '',
            ]"
          >
            <button class="list__item-edit-btn" @click="editText(index)">
              <i class="fas fa-edit"></i>
            </button>
    
            <button
              class="list__item-save-btn"
              @click="onChange(index, topic)"
            >
              <i class="fas fa-save"></i>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

// Utils
import { plural } from '@/assets/js/text-utils';

export default {
  data() {
    return {
      topicList: [],
      activeIndex: null,
      inputHours: [1, 2, 3, 4, 5],
      inputHour: "",
      inputType: "",
      disciplineId: null
    };
  },

  props: {
    groupId: {
      type: String,
      default: ''
    },
  },

  watch: {
    groupId() {
      this.fechData();
    }
  },

  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },

  async created() {
    await this.fechData();
  },

  methods: {
    plural,

    dateCorrect(value) {
      return this.globalFunctions.dateCorrector(value);
    },

    async editText(index) {
      this.activeIndex = index;
      let item = `item-${index}`;
      await this.$nextTick();
      this.$refs[item][0].focus();
    },

    cancelUpdate(index, value) {
      this.$refs[`item-${index}`][0].innerText = value.theme ? value.theme : "";
      this.activeIndex = null;
    },

    onChange(index, value) {
      const theme = this.$refs[`item-${index}`][0].innerText;

      if (theme.length === 0) {
        this.notify(false, "Название темы не может быть пустым");
        return;
      }

      const { type, hour, datetime, id } = value;

      const splitedDateTime = datetime.split(' ');
      const date = splitedDateTime[0];
      const time = splitedDateTime[1];

      this.saveData({ type, hour, theme, id, datetime: `${this.$moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY') } ${time}`});
    },

    async saveData({ type, hour, theme, id, datetime }) {
      try {
        const { data: { status, messages } } = await this.axios.put(`api/journal/presence/${id}/themes/${this.groupId}`, {
          theme,
          type,
          hour,
          datetime,
          disciplineId: this.disciplineId
        });

        this.notify(status, messages);

        this.activeIndex = null;

        this.fechData();
      } catch (e) {
        console.warn('Error [topicsСovered/saveChange]', e)
      }
    },

    notify(status, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
          text
        ),
      });
    },

    async fechData() {
      try {
        const { status, data } = await this.axios.get(`api/journal/presence/${this.$route.params.sid}/themes/${this.groupId}`);

        if (status === 200) {
          this.topicList = data.themes;
          this.disciplineId = data.disciplineId;
        }
      } catch (e) {
        console.warn("Error fetch [Presence/fechData]", e);
      }
    },
  },
};
</script>

<style lang="scss">
.topic-covered {
  padding-bottom: 20px;

  .topic-covered__list {
    list-style: none;
    display: grid;
    row-gap: 20px;
    max-width: 100%;
    width: 100%;
  }

  .list__item {
    position: relative;
    display: grid;
    align-items: center;
    column-gap: 10px;
    grid-template-areas: "date text-content buttons";
    grid-template-columns: max-content 1fr max-content;
    color: $regular-text-clr;
    i {
      transition-property: color;
      transition-duration: 0.3s;
      color: $secondary-text-clr;
      cursor: pointer;
      font-size: 20px;
      &:hover {
        color: $brand-clr-1;
      }
    }
  }

  .list__item-date {
    grid-area: date;
  }

  .item-text__wrp {
    position: relative;
    grid-area: text-content;
  }

  .button-box {
    grid-area: buttons;
  }

  .list__control-block {
    position: absolute;
    display: grid;
    align-items: center;
    grid-template-columns: max-content max-content;
    grid-template-rows: max-content max-content;
    column-gap: 20px;
    row-gap: 10px;
    background-color: $basic-white;
    width: 100%;
    transform: translateY(0);
    z-index: 5;
    align-items: center;
    margin: 0 auto;
    padding: 20px 10px 10px 10px;
    border-radius: 0 0 5px 5px;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
    -moz-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
    box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: transform 0.3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    transform: translateY(0);
  }

  .item-text__wrp {
    position: relative;
  }

  .list__item-text {
    transition-duration: 0.3s;
    transition-property: border-color;
    outline: none;
    padding: 10px;
    padding-right: 40px;
    border: 1px solid transparent;
    border-radius: 5px;
    position: relative;
    background-color: $basic-white;
  }

  .focus-active {
    border-color: $brand-clr-1;
    z-index: 10;
  }

  .button-box {
    overflow: hidden;
    width: 25px;
    height: 25px;

    button {
      padding: 2px;
    }
  }

  .button-container {
    transition-duration: 0.3s;
    transition-property: transform;
    display: grid;
    grid-template-rows: 1fr;
    justify-items: center;
  }

  .container-shift {
    transform: translateY(-50%);
  }

  .list__item-cancel-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -15px;
    z-index: 12;

    i {
      font-size: 25px;
    }
  }

  @media (max-width: 800px) {
    .list__item {
      padding: 10px;
      border-radius: 5px;
      -webkit-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      -moz-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      grid-template-columns: 1fr max-content;
      grid-template-areas:
        "date buttons"
        "text-content buttons";
    }

    .list__item-date {
      padding-left: 10px;
    }

    .list__control-block {
      grid-template-columns: 1fr;
    }
  
    .lable-select-hour {
      order: 1;
    }
  
    .lable-select-type {
      order: 3;
    }
  
    .select-hour {
      order: 2;
    }
  
    .item-text__wrp {
      order: 3;
    }
  }
}
</style>
